export default "__VITE_ASSET__DIix1Bov__"